import type { AdminUser, AuthToken } from "@/types";
import { apiClient } from "./client";

export interface LoginBody {
  email: string;
  password: string;
}

export interface RegisterBody {
  email: string;
  password: string;
  name: string;
}

export const authService = {
  register: async (body: RegisterBody): Promise<AuthToken> => {
    const { data } = await apiClient.post<AuthToken>("/auth/register", body);
    return data;
  },

  login: async (body: LoginBody): Promise<AuthToken> => {
    const { data } = await apiClient.post<AuthToken>("/auth/login", body);
    return data;
  },

  googleLogin: async (idToken: string): Promise<AuthToken> => {
    const { data } = await apiClient.post<AuthToken>("/auth/google", { id_token: idToken });
    return data;
  },

  me: async (): Promise<AdminUser> => {
    const { data } = await apiClient.get<AdminUser>("/auth/me");
    return data;
  },
};
